<template>
  <div id="payPassword">
    <mt-header fixed :title="$t('支付密码')">
      <mt-button
        icon="back"
        slot="left"
        @click.native="$router.back()"
      ></mt-button>
    </mt-header>
    <div class="container">
      <router-link to="/rePayPassword" replace>
        <mt-cell :title="$t('修改支付密码')" is-link></mt-cell>
      </router-link>
    </div>

    <div class="container2">
      <router-link to="/forgetPayPass" replace>
        <mt-cell :title="$t('忘记支付密码')" is-link></mt-cell>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
#payPassword {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
.mint-header {
  background: #ffffff;
  color: #212529;
  border-bottom: 1px solid #e3e8ed;
}
.mint-button--default {
  color: #656b79 !important;
}
.container {
  padding: 50px 10px 10px 10px;
}
.swiper {
  height: 80px;
}
.swiper img {
  width: 100%;
  max-height: 100%;
  border-radius: 10px;
}
.container2 {
  padding: 10px 10px 10px 10px;
}
</style>
